import { render, staticRenderFns } from "./BaseBoardSku.vue?vue&type=template&id=2f77b4ee&scoped=true&"
import script from "./BaseBoardSku.vue?vue&type=script&lang=js&"
export * from "./BaseBoardSku.vue?vue&type=script&lang=js&"
import style0 from "./BaseBoardSku.vue?vue&type=style&index=0&id=2f77b4ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f77b4ee",
  null
  
)

export default component.exports